import { parseJsonObject } from 'common/utils/graphqlJson';

export const getCityOptions = (cities) => cities.map((city) => ({ value: city, label: city }));

// `country`/`state` son campos GraphQL `JSON`: llegan serializados, pero en formularios ya
// montados pueden venir como objeto. parseJsonObject cubre ambos casos sin lanzar.
export const getCountryFromJson = (countryJsonString) => parseJsonObject(countryJsonString);

export const getCountryOptions = (countries) =>
  countries.map((country) => ({ value: country.Iso2, label: country.name }));

export const getStateOptions = (states) =>
  states.map((state) => ({ value: state.state_code, label: state.name }));
